import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { UserDisplayName, SecondaryButton, IconSpinner } from '../../components';
import { IconShevronLeft, IconEyeL, IconMatchL } from '../../icons';
import css from './TransactionPanel.css';

const TransactionPanelNav = ({
    navSectionClassName,
    history,
    otherParty,
    isAnonym,
    otherPartyUserType,
    otherPartyId,
    matchingMatrixLoading,
    matchingScore,
    setMatchingModalOpen,
    noListingInfo,
    isListingDeleted,
    asidePanelVisible,
    setAsidePanelVisibility,
}) => (
    <nav
        className={classNames(css.navSection, {
            [navSectionClassName]: !!navSectionClassName,
        })}
    >
        <p
            className={css.navigateToInbox}
            onClick={() => {
                history.push(
                    createResourceLocatorString('OrderMessagesPage', routeConfiguration())
                );
            }}
        >
            <IconShevronLeft />
            <FormattedMessage id="TransactionPanel.navigateToInbox" />
        </p>
        <h2 className={css.otherPartyProfileInfo}>
            <UserDisplayName user={otherParty} shouldBeTrimmed={isAnonym} />
            {!isAnonym && (
                <IconEyeL
                    clickHandler={() =>
                        history.push(
                            createResourceLocatorString(
                                'ProfilePage',
                                routeConfiguration(),
                                {
                                    userType: otherPartyUserType,
                                    id: otherPartyId,
                                },
                                {}
                            )
                        )
                    }
                />
            )}
        </h2>
        <aside className={css.asidePanelDesktop}>
            {matchingMatrixLoading && <IconSpinner />}
            {matchingScore && (
                <SecondaryButton
                    type="button"
                    onClick={() => setMatchingModalOpen(previous => !previous)}
                    className={css.asidePanelActivePermanently}
                >
                    <IconMatchL />
                    <span>Matching ansehen</span>
                </SecondaryButton>
            )}
            <SecondaryButton
                type="button"
                onClick={() => {
                    if (noListingInfo || isListingDeleted) return;
                    setAsidePanelVisibility(!asidePanelVisible);
                }}
                className={classNames({
                    [css.asidePanelActionHighlighted]: asidePanelVisible,
                    [css.asidePanelActionDisabled]: noListingInfo || isListingDeleted,
                })}
            >
                Details anzeigen
            </SecondaryButton>
        </aside>
        <div
            className={classNames(css.asidePanelMob, {
                [css.asidePanelMobDisabled]: noListingInfo || isListingDeleted,
            })}
        >
            {matchingScore && (
                <code
                    className={css.matchingMobElem}
                    onClick={() => setMatchingModalOpen(previous => !previous)}
                >
                    <IconMatchL />
                </code>
            )}
            <span
                onClick={() => {
                    if (noListingInfo || isListingDeleted) return;
                    setAsidePanelVisibility(true);
                }}
                className={css.ellipsis}
            >
                ...
            </span>
        </div>
    </nav>
);

export default TransactionPanelNav;
